import { Link } from "react-router";
import { PanelRightOpen } from "lucide-react";
import { SidebarNavigation } from "@/features/navigation/components/SidebarNavigation";
import { AnimatedOrganizationBrand } from "@/shared/components/AnimatedOrganizationBrand";
import {
  Sidebar,
  SidebarHeader,
  useSidebar,
} from "@/shared/components/ui/sidebar";

type AppSidebarProps = {
  mobileSections?: React.ReactNode
  onMainNavigationClose?: () => void
  forceOpenBlogDrawer?: boolean
  forceOpenBoutiqueDrawer?: boolean
  forceOpenDealsDrawer?: boolean
};

function AppSidebar({
  mobileSections,
  onMainNavigationClose,
  forceOpenBlogDrawer,
  forceOpenBoutiqueDrawer,
  forceOpenDealsDrawer,
}: AppSidebarProps) {
  const { setOpenMobile, open, isMobile } = useSidebar();

  const handleLogoClick = () => {
    setOpenMobile(false);
  };

  const isSidebarCollapsed = !open && !isMobile;

  return (
    <Sidebar side="left" variant="sidebar" collapsible="icon">
      <SidebarHeader className="border-b border-sidebar-border relative">
        {isMobile && (
          <button
            type="button"
            onClick={() => setOpenMobile(false)}
            className="absolute top-2 right-2 p-2 rounded-md text-sidebar-foreground hover:bg-sidebar-accent transition-colors z-10"
            aria-label="Fermer le menu"
          >
            <PanelRightOpen size={20} />
          </button>
        )}
        <Link
          to="/"
          className="flex items-center justify-center px-2 py-2"
          onClick={handleLogoClick}
        >
          <AnimatedOrganizationBrand
            isCollapsed={isSidebarCollapsed}
            compact={isMobile}
          />
        </Link>
      </SidebarHeader>
      <SidebarNavigation
        mobileSections={mobileSections}
        onMainNavigationClose={onMainNavigationClose}
        forceOpenBlogDrawer={forceOpenBlogDrawer}
        forceOpenBoutiqueDrawer={forceOpenBoutiqueDrawer}
        forceOpenDealsDrawer={forceOpenDealsDrawer}
      />
    </Sidebar>
  );
}

AppSidebar.displayName = "AppSidebar";

export { AppSidebar };
